// "What kind of group is this?" (owner 2026-10-07). Each type comes with a few
// pre-written starter descriptions, so they're instant and always on-brand.
// The keys match the groups.group_type CHECK constraint.

export const GROUP_TYPES = [
  {
    key: 'brand',
    label: 'Brand / Influencer',
    hint: 'Your followers or customers play along with you',
    starters: [
      "Think you can out-pick us? Join our crew, fill out your bracket every tournament and see who really knows pro pickleball. Top of the leaderboard gets the bragging rights.",
      "Our community, our brackets. Make your picks for every tournament, climb the group leaderboard and show the rest of the squad how it's done.",
      "This is where our fans go head to head. Pick the winners, follow the action live and fight for the top spot all season long.",
    ],
  },
  {
    key: 'fan',
    label: 'MLP / Pro Player Fan Group',
    hint: 'Fans of a team or player picking together',
    starters: [
      "For the fans who never miss a match. Pick every bracket, cheer on our team and prove you're the biggest fan in the group.",
      "We live for game day. Make your picks, ride the highs and lows together and battle for fan-club bragging rights every tournament.",
      "One team, one group, one champ. Join fellow fans, call the upsets before they happen and see who tops the leaderboard.",
    ],
  },
  {
    key: 'friendly',
    label: 'Friendly Competition',
    hint: 'Work, family or your local pickleball crew',
    starters: [
      "A little friendly competition never hurt anyone. Make your picks, talk some trash and see who takes the crown this tournament.",
      "Same people we dink with, now we pick with them too. Fill out your bracket and let the bragging begin.",
      "Family, friends and a scoreboard. Make your picks each tournament and settle once and for all who knows pickleball best.",
    ],
  },
]

export function groupTypeLabel(key) {
  return GROUP_TYPES.find(t => t.key === key)?.label || null
}

// A starter for the type, different from `current` when there is a choice.
export function pickStarter(key, current = '', random = Math.random) {
  const starters = GROUP_TYPES.find(t => t.key === key)?.starters || []
  const options = starters.length > 1 ? starters.filter(s => s !== current) : starters
  return options[Math.floor(random() * options.length)] || ''
}

export function isStarter(text) {
  return GROUP_TYPES.some(t => t.starters.includes(text))
}
